// App-level components that don't need authentication
// When migrating to React, these can be moved to appropriate locations

export function IntercomComponent() {
  return <></>
}

// Export as an object for easier access
export const AppComponents = {
  IntercomComponent
}
